goog.provide("shadow.js.shim.module$$mui$material$Icon");
goog.provide("module$shadow_js_shim_module$$mui$material$Icon");
shadow.js.shim.module$$mui$material$Icon = shadow.js.nativeProvides["@mui/material/Icon"] = shadow$bridge("@mui/material/Icon");
module$shadow_js_shim_module$$mui$material$Icon.default = shadow.js.shim.module$$mui$material$Icon;
